// import React from 'react';
// import Box from '@mui/material/Box';
// import Toolbar from '@mui/material/Toolbar';
// import { createTheme, ThemeProvider } from '@mui/material/styles';
// import { Container } from '@mui/material';
// import DashTheme from './DashTheme';
// import FindRelationComponent from './FindRelationComponent';
// import Upgrade from './Upgrade';
 


// export default function Dashboard() {
//     const [open, setOpen] = React.useState(true);
//     const toggleDrawer = () => {
//         setOpen(!open);
//     };


//     // TODO remove, this demo shouldn't need to reset the theme.
//     const defaultTheme = createTheme();

//     return (
//         <ThemeProvider theme={defaultTheme}>
//             <Box sx={{ display: 'flex' }}>
//                 <DashTheme />
//                 <Box
//                     component="main"
//                     sx={{
//                         backgroundColor: (theme) =>
//                             theme.palette.mode === 'light'
//                                 ? theme.palette.grey[100]
//                                 : theme.palette.grey[900],
//                         flexGrow: 1,
//                         height: '100vh',
//                         overflow: 'auto',
//                     }}
//                 >
//                     <Toolbar />
//                     <Container maxWidth="lg" sx={{ mt: 4, mb: 2 }}>

                      
//                         {/* ---------------------------------------------------------------------------------------------- */}
//                         <Upgrade/>
                         
//                         {/* ---------------------------------------------------------------------------------------------- */}
//                     </Container>
//                 </Box>
//             </Box>
//         </ThemeProvider>
//     );
// }


import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Container } from '@mui/material';
import DashTheme from './DashTheme';
import Upgrade from './Upgrade';

export default function Dashboard() {
    const [open, setOpen] = React.useState(true);
    const userId = localStorage.getItem('userId');
    const storageKey = `isPremium_${userId}`;

    const [isPremium, setIsPremium] = useState(
        localStorage.getItem(storageKey) === 'true'
    );

    const defaultTheme = createTheme();

useEffect(() => {
    const syncHandler = () => {
        setIsPremium(localStorage.getItem(storageKey) === 'true');
    };

    window.addEventListener('goldpetals:access-refresh', syncHandler);

    return () => {
        window.removeEventListener('goldpetals:access-refresh', syncHandler);
    };
}, [storageKey]);


    return (
        <ThemeProvider theme={defaultTheme}>
            <Box sx={{ display: 'flex' }}>
                <DashTheme />

                <Box
                    component="main"
                    sx={{
                        backgroundColor: (theme) =>
                            theme.palette.mode === 'light'
                                ? theme.palette.grey[100]
                                : theme.palette.grey[900],
                        flexGrow: 1,
                        height: '100vh',
                        overflow: 'auto',
                    }}
                >
                    <Toolbar />

                    <Container maxWidth="lg" sx={{ mt: 4, mb: 2 }}>

                        {/* ✅ Conditional Rendering */}
                        <Upgrade />

                        {/* OR if you want strict control */}
                        {/* 
                        {isPremium ? (
                            <div>Premium Dashboard Content</div>
                        ) : (
                            <Upgrade />
                        )}
                        */}

                    </Container>
                </Box>
            </Box>
        </ThemeProvider>
    );
}